import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);

	const location = useLocation();

	const closeMenu = () => setMenuOpen(false);

	const getSectionLink = (section) => {
		return location.pathname === "/"
			? `#${section}`
			: `/#${section}`;
	};

	return (
		<nav className="navbar navbar-expand-lg custom-navbar fixed-top">
			<div className="container">

				<Link
					className="navbar-brand brand-logo"
					to="/"
					onClick={closeMenu}
				>
					<div className="logo-icon">
						<i className="bi bi-person-vcard"></i>
					</div>

					<div className="logo-content">
						<span className="brand-main">ITHE</span>
						<span className="brand-sub">Cards Solutions</span>
					</div>
				</Link>

				<button
					className="navbar-toggler"
					type="button"
					onClick={() => setMenuOpen(!menuOpen)}
				>
					<i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"} fs-1`}></i>
				</button>

				<div
					className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
				>

					<ul className="navbar-nav mx-auto">

						<li className="nav-item">
							<Link
								className="nav-link"
								to="/"
								onClick={closeMenu}
							>
								Home
							</Link>
						</li>

						<li className="nav-item">
							<a
								className="nav-link"
								href={getSectionLink("about")}
								onClick={closeMenu}
							>
								About
							</a>
						</li>

						<li className="nav-item">
							<a
								className="nav-link"
								href={getSectionLink("products")}
								onClick={closeMenu}
							>
								Products
							</a>
						</li>

						<li className="nav-item">
							<a
								className="nav-link"
								href={getSectionLink("reviews")}
								onClick={closeMenu}
							>
								Reviews
							</a>
						</li>

						<li className="nav-item">
							<Link
								className="nav-link"
								to="/portfolio"
								onClick={closeMenu}
							>
								Portfolio
							</Link>
						</li>

						<li className="nav-item">
							<a
								className="nav-link"
								href={getSectionLink("contact")}
								onClick={closeMenu}
							>
								Contact
							</a>
						</li>

					</ul>

				</div>

			</div>
		</nav>
	);
};

export default Header;